import script from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=ts"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=191b29de&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191b29de"]])

export default __exports__